import InboomaBaseView from "../../InboomaBaseView";

import TransactionsSortTabsViewTpl from "../../../templates/myInbooma/TransactionsSortTabsViewTpl.html";

export default InboomaBaseView.extend({
  template: TransactionsSortTabsViewTpl,
  el: "#inb-c-main-sort-nav",

  events: {
    "click li.tabs-title": "_onClickChangeSort",
  },

  initialize() {
    this.render();
  },

  _onClickChangeSort(ev) {
    const el = ev.currentTarget;

    const sortKey = el.getAttribute("data-inb-val"),
      direction = el.getAttribute("data-inb-direction"),
      isOppositeElement = direction === null && el.classList.contains("is-active");

    let newDirection = direction === "desc" ? "asc" : "desc";

    if (isOppositeElement) {
      newDirection = "asc";
    }

    if (sortKey) {
      this.collection.setSort(sortKey, newDirection);

      const activeSortTab = this.$el[0].querySelector(".is-active");

      // @todo remove/set aria-selected attribute
      activeSortTab.classList.remove("is-active");
      el.classList.add("is-active");
      el.setAttribute("data-inb-direction", newDirection);
    }

    return false;
  },
});
